"use client";

import React from "react";
import "./FieldError.css";

interface FieldErrorProps {
  children?: React.ReactNode;
}

const FieldError: React.FC<FieldErrorProps> = ({ children }) => {
  if (!children) return null;
  return <p className="field-error">⚠️ {children}</p>;
};

export default FieldError;
